export default __webpack_public_path__ + "static/media/main-car.caaa62d0.png";